import { ReactNode } from 'react';

import useFeatureFlag from 'lib/hooks/useFeatureFlag';
import { FeatureFlag } from 'lib/interfaces/feature-flags';

interface FeatureFlaggedProps {
  featureFlag: FeatureFlag;
  children: ReactNode;
  fallback?: ReactNode;

  /**
   * Invert the feature flag check. If true, the children will be rendered when the feature flag is not enabled.
   */
  invert?: boolean;
}

const FeatureFlagged = ({
  children,
  featureFlag,
  fallback = null,
  invert,
}: FeatureFlaggedProps) => {
  const hasFeatureFlag = useFeatureFlag(featureFlag);

  return <>{(invert ? !hasFeatureFlag : hasFeatureFlag) ? children : fallback}</>;
};

export default FeatureFlagged;
